import { Plug, Zap, FileText } from "lucide-react"
import { Tagline } from "@/components/pro-blocks/landing-page/tagline"
import { Card } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"

export function FeatureSection9() {
  return (
    <section className="bg-secondary section-padding-y border-b" id="how-it-works">
      <div className="container-padding-x container mx-auto flex flex-col gap-10 md:gap-12">
        <div className="section-title-gap-lg mx-auto flex max-w-xl flex-col items-center text-center">
          <Tagline>Как это работает</Tagline>
          <h2 className="heading-lg text-foreground">3 простых шага</h2>
          <p className="text-muted-foreground text-base">
            FeedbackIQ автоматически читает все ваши обращения, понимает их суть, группирует похожие проблемы и
            показывает, что требует внимания.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          <Card className="bg-background flex flex-col items-center gap-5 p-6 text-center">
            <div className="bg-primary/10 flex h-14 w-14 items-center justify-center rounded-2xl">
              <Plug className="text-primary h-7 w-7" />
            </div>
            <div className="flex flex-col gap-2">
              <Badge variant="secondary" className="mx-auto w-fit">
                Шаг 1
              </Badge>
              <h3 className="text-foreground text-lg font-semibold">Подключение за 5 минут</h3>
              <p className="text-muted-foreground text-sm">
                Войдите через аккаунт Zendesk, Intercom или Help Scout. Разрешите доступ — готово.
              </p>
            </div>
          </Card>

          <Card className="bg-background flex flex-col items-center gap-5 p-6 text-center">
            <div className="bg-primary/10 flex h-14 w-14 items-center justify-center rounded-2xl">
              <Zap className="text-primary h-7 w-7" />
            </div>
            <div className="flex flex-col gap-2">
              <Badge variant="secondary" className="mx-auto w-fit">
                Шаг 2
              </Badge>
              <h3 className="text-foreground text-lg font-semibold">Автоматический анализ</h3>
              <p className="text-muted-foreground text-sm">
                Каждое обращение проходит анализ: категория, критичность, связанные проблемы, бизнес-влияние.
              </p>
            </div>
          </Card>

          <Card className="bg-background flex flex-col items-center gap-5 p-6 text-center">
            <div className="bg-primary/10 flex h-14 w-14 items-center justify-center rounded-2xl">
              <FileText className="text-primary h-7 w-7" />
            </div>
            <div className="flex flex-col gap-2">
              <Badge variant="secondary" className="mx-auto w-fit">
                Шаг 3
              </Badge>
              <h3 className="text-foreground text-lg font-semibold">Готовые выводы</h3>
              <p className="text-muted-foreground text-sm">
                Получайте уведомления о критических проблемах и еженедельный дайджест с топ-5 проблем.
              </p>
            </div>
          </Card>
        </div>
      </div>
    </section>
  )
}
